<template>
  <b-card-code title="Light">
    <b-card-text class="mb-0">
      <!-- <span>Use </span>
      <code>.btn-flat-{color}</code>
      <span> to create a flat button.</span> -->
      Use light button with a filled button for secondary action, such as "Cancel". Or, as a link button.
    </b-card-text>

    <div class="demo-inline-spacing">
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        class="btn-light-primary"
      >
        Primary
      </b-button>
      <b-button
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        class="btn-light-secondary"
      >
        Secondary
      </b-button>
      <b-button
        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        class="btn-light-success"
      >
        Success
      </b-button>

      <b-button
        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
        class="btn-light-danger"
      >
        Danger
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 159, 67, 0.15)'"
        class="btn-light-warning"
      >
        Warning
      </b-button>
      <b-button
        v-ripple.400="'rgba(0, 207, 232, 0.15)'"
        class="btn-light-info"
      >
        Info
      </b-button>
      <!-- <b-button
        v-ripple.400="'rgba(30, 30, 30, 0.15)'"
        variant="flat-dark"
      >
        Dark
      </b-button> -->
    </div>

    <template #code>
      {{ codeButtonLight }}
    </template>
  </b-card-code>
</template>

<script>
import { BButton, BCardText } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import { codeButtonLight } from './code'

export default {
  components: {
    BCardCode,
    BButton,
    BCardText,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      codeButtonLight,
    }
  },
}
</script>
